/** External CSS */
import "./index.css"
import { TemperatureWidget } from "../TemperatureWidget"

export const IsotopesPage = () => {
    return (<div className="main-container">
    
        <TemperatureWidget></TemperatureWidget>
    </div>)
}